import React__default, { Component } from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { KEYS_CHARCODE } from '../consts.js';
import SearchIcon from '../Icons/SearchIcon.js';
import ClearIcon from '../Icons/ClearIcon.js';
import 'wix-rich-content-common';

var css_248z = ".svezO{display:flex;position:relative}.svezO:hover{color:var(--ricos-settings-text-color,#000)}.k44OE{color:var(--ricos-settings-text-color,#333);font-size:16px;font-weight:300;height:40px;line-height:16px;width:100%}[dir] .k44OE{border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6));border-radius:var(--ricos-settings-inputs-border-radius,0)}[dir=ltr] .k44OE{padding-left:37px}[dir=rtl] .k44OE{padding-right:37px}.k44OE::placeholder{color:var(--ricos-settings-inputs-placeholder-color,#646464)}[dir] .k44OE:focus,[dir] .k44OE:hover{border:1px solid rgba(var(--ricos-settings-action-color-tuple,0,0,0),.5)!important}.HeHkL,.QZu9P{fill:var(--ricos-settings-icons-color,#000);bottom:0;color:var(--ricos-settings-icons-color,#000);position:absolute;top:0;width:24px}[dir] .HeHkL,[dir] .QZu9P{margin:auto}[dir=ltr] .QZu9P{left:7px}[dir=rtl] .QZu9P{right:7px}.HeHkL{height:16px;width:16px}[dir] .HeHkL{background-color:#f0f0f0;border-radius:50%;cursor:pointer}[dir=ltr] .HeHkL{right:11px}[dir=rtl] .HeHkL{left:11px}";
var styles = {"container":"svezO","input":"k44OE","prefixIcon":"QZu9P","suffixIcon":"HeHkL"};
styleInject(css_248z);

class TextSearchInput extends Component {
  constructor() {
    super(...arguments);
    this.input = null;
    this.onChange = (e) => this.props.onChange(e.target.value);
    this.onCloseRequested = () => {
      var _a, _b;
      (_b = (_a = this.props).onClose) == null ? void 0 : _b.call(_a);
    };
    this.handleKeyPress = (e) => {
      var _a;
      if (e.charCode === KEYS_CHARCODE.ESCAPE) {
        this.onCloseRequested();
      }
      if (e.charCode === KEYS_CHARCODE.ENTER) {
        const elements = Array.from(
          document.querySelectorAll("button,input")
        );
        const searchInputIndex = elements.indexOf(e.target);
        (_a = elements[searchInputIndex + 1]) == null ? void 0 : _a.click();
      }
    };
    this.handleClearText = () => this.props.onChange("");
  }
  componentDidMount() {
    if (this.input) {
      setTimeout(() => {
        var _a;
        return (_a = this.input) == null ? void 0 : _a.focus();
      }, 0);
      this.input.setSelectionRange(0, this.input.value.length);
    }
  }
  render() {
    const { placeHolder, value } = this.props;
    return /* @__PURE__ */ React__default.createElement("div", { className: styles.container }, /* @__PURE__ */ React__default.createElement(SearchIcon, { className: styles.prefixIcon }), /* @__PURE__ */ React__default.createElement(
      "input",
      {
        ref: (ref) => {
          this.input = ref;
        },
        className: styles.input,
        placeholder: placeHolder,
        onKeyPress: this.handleKeyPress,
        onChange: this.onChange,
        value
      }
    ), value && /* @__PURE__ */ React__default.createElement(ClearIcon, { className: styles.suffixIcon, onClick: this.handleClearText }));
  }
}

export { TextSearchInput as default };
//# sourceMappingURL=TextSearchInput.js.map
